import {OEMediaCenterAutoplayMode} from '../../components/controller/media-center/oe-media-center-model.js';
import OEStrEncoder, {OEStrEncoderResult} from './oe-str-encoder.js';
import OEToolbox from './oe-toolbox.js';
import urlQueries from '../../config/url-queries.js';

export const OEURLParameter = {
    autoplay:                               'autoplay',
    customer:                               'customer',
    flags:                                  'flags',
    labelsEnabled:                          'labelsEnabled',
    labelsLatin:                            'labelsLatin',
    noContextMenu:                          'noContextMenu',
    license:                                'license',
    link:                                   'link',
    linkRef:                                'linkRef',
    showFullscreenBtn:                      'showFullscreenBtn',
    noFullscreen:                           'noFullscreen',
    noTitleBar:                             'noTitleBar',
    noStartView:                            'noStartView',
    status:                                 'status',
    showMainMenu:                           'showMainMenu',
    showTitleBar:                           'showTitleBar',
    target:                                 'target',
    uiLink:                                 'uiLink',
    uiLinkRef:                              'uiLinkRef',
    mcVisible:                              'mcVisible',
    category:                               'category',
    item:                                   'item',
    subItem:                                'subItem',
    resourceId:                             'resourceId',
    progress:                               'progress',
    loadFlags:                              'lf',
};

export const OEURLParamType = {
    string:                                 'string',
    integer:                                'integer',
    float:                                  'float',
    boolean:                                'boolean',
};

export const OEURLParameterDesc = {
    [OEURLParameter.autoplay]:              {type: OEURLParamType.integer, min: OEMediaCenterAutoplayMode.none, max: Math.max(...OEMediaCenterAutoplayMode.all)},
    [OEURLParameter.customer]:              {type: OEURLParamType.string},
    [OEURLParameter.flags]:                 {type: OEURLParamType.string},
    [OEURLParameter.labelsEnabled]:         {type: OEURLParamType.boolean},
    [OEURLParameter.labelsLatin]:           {type: OEURLParamType.boolean},
    [OEURLParameter.noContextMenu]:         {type: OEURLParamType.boolean},
    [OEURLParameter.license]:               {type: OEURLParamType.string},
    [OEURLParameter.link]:                  {type: OEURLParamType.string},
    [OEURLParameter.linkRef]:               {type: OEURLParamType.string},
    [OEURLParameter.showFullscreenBtn]:     {type: OEURLParamType.integer},
    [OEURLParameter.noFullscreen]:          {type: OEURLParamType.boolean},
    [OEURLParameter.noTitleBar]:            {type: OEURLParamType.boolean},
    [OEURLParameter.noStartView]:           {type: OEURLParamType.boolean},
    [OEURLParameter.status]:                {type: OEURLParamType.string},
    [OEURLParameter.showMainMenu]:          {type: OEURLParamType.integer},
    [OEURLParameter.showTitleBar]:          {type: OEURLParamType.integer},
    [OEURLParameter.target]:                {type: OEURLParamType.string},
    [OEURLParameter.uiLink]:                {type: OEURLParamType.string},
    [OEURLParameter.uiLinkRef]:             {type: OEURLParamType.string},
    [OEURLParameter.mcVisible]:             {type: OEURLParamType.boolean},
    [OEURLParameter.category]:              {type: OEURLParamType.integer},
    [OEURLParameter.item]:                  {type: OEURLParamType.integer},
    [OEURLParameter.subItem]:               {type: OEURLParamType.integer},
    [OEURLParameter.resourceId]:            {type: OEURLParamType.string},
    [OEURLParameter.progress]:              {type: OEURLParamType.float},
    [OEURLParameter.loadFlags]:             {type: OEURLParamType.integer}
};

OEURLParameter.ALL = Object.values(OEURLParameter);

export class OEURLParameterTool {
    
    constructor(queries, URL, verbose = true) {
        this._queries = queries;

        this._params = {};

        this.initURL(URL);

        this.initPrams();

        if(verbose && this.hasParams())    this.print();
    }

    get queries() {
        return this._queries;
    }

    get params() {
        return this._params;
    }

    get rawURL() {
        return this._rawURL;
    }

    get URL() {
        return this._URL;
    }

    hasValue(name)  {
        let value = this._params[name];
        return value !== undefined && value !== null ? true : false;
    }

    getValue(name, defaultValue)    {
        let value = this._params[name];
        return value !== undefined && value !== null ? value : defaultValue;
    }

    numParams()  {
        return Object.keys(this._params).length
    }

    hasParams() {
        return !!this.numParams();
    }

    getValueFromURL(url, name)    {
        let params = url.split('&');
        for(let i = 0; i < params.length; ++i)  {
            let nameValue = params[i].split('=');
            if(nameValue[0] === name)    return nameValue[1];
        }
    }

    initURL(URL)  {
        this._rawURL = typeof(URL) === 'string' ? URL : decodeURIComponent(window.location.search.substring(1));
        this._URL = undefined;

        let url = this._rawURL;

        let p = this.getValueFromURL(url, 'p');
        if(p !== undefined) {
            try {
                url = p ? OEStrEncoder.decodeURL(p) : '';
            } catch(res) {
                console.log('Warning - Decoding of encoded URL paramters failed with - ' + OEStrEncoderResult.toString(res));
                url = '';
            }
        }

        let query = this.getValueFromURL(url, 'q');
        
        if(query)   {
            if(this._queries && typeof(this._queries[query]) === 'string') {
                url = this._queries[query];
            } else {
                console.log("Error: Could not find url query!");
                url = '';
            }
        }

        p = this.getValueFromURL(url, 'p');
        if(p !== undefined) {
            try {
                url = p ? OEStrEncoder.decodeURL(p) : '';
            } catch(res) {
                console.log('Warning - Decoding of encoded URL paramters failed with - ' + OEStrEncoderResult.toString(res));
                url = '';
            }
        }

        this._URL = url;
    }

    initPrams() {
        if(!this._URL)   {
            this._params = {};
            return;
        }

        this._URL.split('&').forEach(v => {
            let nameValue = v.split('=');
            let key = nameValue[0];
            if(!key)    return;
            let value = nameValue[1];
            
            if(value === undefined)    {
                let desc = OEURLParameterDesc[key];
                if(desc && desc.type === OEURLParamType.boolean)    {
                    value = true;
                } else {
                    return;
                }
            }

            this._params[key] = value;
        });

        Object.keys(this._params).forEach(function(key) {
            let desc = OEURLParameterDesc[key];

            let value = desc && desc.type ? this.toType(this._params[key], desc.type) : this._params[key];

            if(desc && typeof(value) === 'number')  {
                if(typeof(desc.min) === 'number')   value = Math.max(desc.min, value);
                if(typeof(desc.max) === 'number')   value = Math.min(desc.max, value);
            }

            this._params[key] = value;
        }.bind(this));
    }

    toType(str, type)   {
        switch(type) {
            case OEURLParamType.integer:    return OEToolbox.toInt(str);
            case OEURLParamType.float:      return OEToolbox.toFloat(str);
            case OEURLParamType.boolean:    return OEToolbox.toBool(str);
        }
        return str;
    }

    print() {
        let keys = Object.keys(this._params);
        let str = !keys.length ? 'No URL parameter' : 'URL parameter:\n';
        if(!keys.length)    {
            console.log(str);
            return;
        }

        keys.forEach((key, i) => {
            let str_ = String(this._params[key]);
            if(str_.length > 128)    str_ = str_.slice(0, 128) + '...'
            str += '    ' + key + ': ' + str_;
            if(i < keys.length - 1) str += ',\n'
        });

        console.log(str);
    }
}

export default new OEURLParameterTool(urlQueries);